import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	snippetEditorModalTitleCreate: {
		id: 'snippets.snippetEditorModal.titleCreate',
		defaultMessage: 'Create block template',
		description: 'Title for the create block template modal',
	},
	snippetEditorModalTitleEdit: {
		id: 'snippets.snippetEditorModal.titleEdit',
		defaultMessage: 'Edit block template',
		description: 'Title for the edit block template modal',
	},
	snippetEditorModalNameLabel: {
		id: 'snippets.snippetEditorModal.nameLabel',
		defaultMessage: 'Template Name',
		description: 'Label for the template name input',
	},
	snippetEditorModalNamePlaceholder: {
		id: 'snippets.snippetEditorModal.namePlaceholder',
		defaultMessage: 'Enter template name',
		description: 'Placeholder for the template name input',
	},
	snippetEditorModalNameError: {
		id: 'snippets.snippetEditorModal.nameError',
		defaultMessage: 'Name is required',
		description: 'Error message for the template name input',
	},
	snippetEditorModalDescriptionLabel: {
		id: 'snippets.snippetEditorModal.descriptionLabel',
		defaultMessage: 'Description',
		description: 'Description label for the modal',
	},
	snippetEditorModalDescriptionPlaceholder: {
		id: 'snippets.snippetEditorModal.descriptionPlaceholder',
		defaultMessage: 'Enter template description',
		description: 'Placeholder for the description input',
	},
	snippetEditorModalAdfError: {
		id: 'snippets.snippetEditorModal.adfError',
		defaultMessage: 'Something went wrong, please make a new content selection',
		description: 'Error message for when the selected ADF is invalid',
	},
	snippetEditorModalCancelButton: {
		id: 'snippets.snippetEditorModal.cancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
	},
	snippetEditorModalCreateButton: {
		id: 'snippets.snippetEditorModal.createButton',
		defaultMessage: 'Create',
		description: 'Create button text for create mode',
	},
	snippetEditorModalSaveButton: {
		id: 'snippets.snippetEditorModal.saveButton',
		defaultMessage: 'Save',
		description: 'Save button text for edit mode',
	},
	snippetEditorModalEditNotAvailableFlag: {
		id: 'snippets.snippetEditorModal.editNotAvailableFlag',
		defaultMessage: 'Edit is not available yet',
		description: 'Info flag shown when edit is not yet supported',
	},
});
